import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ImagBytes } from '../shared/models/imageBytes.model';
import { ImageStampData, PdfAnnotation } from '../Modules/idms/components/plant-manager/models/Pdf-Annotation.model';
import { APIRes } from '../Modules/idms/models/commonAPI.model';
import { ActivityWorkpack, DocumentLink, DocumentList, Documents } from '../Modules/idms/components/plant-manager/models/plant-manager.model';
import { AttachmentDetails, Attachments } from '../Modules/idms/components/project-manager/models/attachments.model';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { SearchedDocumnt } from '../Modules/idms/components/idms/idms-site-search/models/siteSearchTaggedItemModel';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentApiService {
    headers: HttpHeaders;
    viewingSessionId: string;
    docApi = environment.docApi;
    private subVal = '';
    private logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
    constructor(
        private http: HttpClient,
        private authService: MsalService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights
    ) {
        this.subVal = this.EnvironmentService.getConfig().subValue;
    }

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('Accept', 'application/json;');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*/*');
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('instanceId', `${localStorage.getItem('currentInstanceId')}`);
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
    }

    private createHttpParams(params: {}): HttpParams {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach((param) => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });

        return httpParams;
    }

    getImgBytes(imgUrl: any): Observable<APIRes<ImagBytes>> {
        this.addPostAndPutHeaders();
        const queryParams = this.createHttpParams({ path: imgUrl });
        return this.http.get(`${this.docApi}blob/getfiledata`, { headers: this.headers, params: queryParams }).pipe(catchError(this.handleError.bind(this)));
    }

    private handleError(error: any) {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        const currOrg = localStorage.getItem('selectedOrgId');
        const currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            // A client-side or network error occurr ed. Handle it accordingly.
            console.error('An error occurred:', error.message);

            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            //this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
           // this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        }
        // Return an observable with a user-facing error message.
        return throwError('Something bad happened; please try again later.');
    }

    // * api call to save the marks on layers
    saveAnnotations(documentId: string, layerId: string, layer: any) {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        return this.http
            .put(`${this.docApi}markups/${documentId}`, [{ markupId: layerId, markup: JSON.stringify(layer) }], { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the viewing sessionId
    getViewingSessionIdandLayerData(documentId: string): Observable<APIRes<PdfAnnotation>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        return this.http.get(`${this.docApi}prizmDoc/open/${documentId}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to create markup burn (it's prerequisite call for part of downloading pdf process)
    createMarkupBurn(marks: any): Observable<any> {
        return this.http.post(`/pas-proxy/ViewingSession/u${this.viewingSessionId}/MarkupBurner`, { marks: marks });
    }

    // * api call to process markup burn (it's prerequisite call for part of downloading pdf process)
    processMarkupBurn(processId: string): Observable<any> {
        return this.http.get(`/pas-proxy/ViewingSession/u${this.viewingSessionId}/MarkupBurner/${processId}`);
    }

    // * api call to download the annotation pdf
    downloadFile(processId: string): Observable<any> {
        return this.http
            .get(`/pas-proxy/ViewingSession/u${this.viewingSessionId}/MarkupBurner/${processId}/Document`, { responseType: 'arraybuffer' })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get all ImageStamps
    getListOfImageStamps(): Observable<APIRes<ImageStampData[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.docApi}prizmDoc/getImageStamps`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to favourite the document
    favouriteDocument(documentId: string, isFavourite: boolean): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        return this.http
            .put(
                `${this.docApi}documents/favourite`,
                [
                    {
                        entityId: documentId,
                        active: isFavourite,
                    },
                ],
                { headers: this.headers }
            )
            .pipe(catchError(this.handleError.bind(this)));
    }

    getDocumentsList(viewid: string, search?: string): Observable<APIRes<DocumentList>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        const queryParams = new HttpParams().set('viewid', viewid).set('search', search).set('all', true);
        return this.http
            .get(`${this.docApi}documents/getdocuments`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get activity packs associated with tagged item
    getdocumentlinkactivitypacks(documentId: string): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        return this.http
            .get(`${this.docApi}documentlinks/getdocumentlinkactivitypacks?documentid=${documentId}&includeAllocations=true`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to upload image for tagged items ************************** */
    uploadTaggedItemImage(formData: FormData): Observable<APIRes<ImagBytes>> {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
        return this.http.post(`${this.docApi}blob`, formData, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to upload Images ************************** */
    getUploadedImage(params: any, instanceId: string): Observable<APIRes<ImagBytes[]>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', instanceId);
        return this.http.post(`${this.docApi}blob/getfiledata`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to get all documents ************************** */
    getDocuments(
        viewid: string,
        taggedItemId?: string,
        startIndex?: number,
        endIndex?: number,
        search?: string,
        status?: any
    ): Observable<APIRes<DocumentList>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        let queryParams = new HttpParams()
            .set('viewid', viewid)
            .set('startIndex', startIndex ?? 0)
            .set('endIndex', endIndex ?? 10)
            .set('search', search ?? null);

        // ✅ Add stateOptions dynamically
        if (status?.Id == 1) {
            queryParams = queryParams.append('all', true);
        } else if (status?.Id == 2) {
            // queryParams = queryParams.append('all', taggedItemId);
            queryParams = queryParams.append('allocated', true);
        } else if (status?.Id == 3) {
            queryParams = queryParams.append('unallocated', true);
        } else if (status?.Id == 4) {
            queryParams = queryParams.append('allocated', true);
            queryParams = queryParams.append('noattachments', true);
        } else if (status?.Id == 5) {
            queryParams = queryParams.append('unallocated', true);
            queryParams = queryParams.append('noattachments', true);
        }
        if (taggedItemId) {
            // queryParams = queryParams.set('entityid', taggedItemId);
            queryParams = queryParams.append('entityid', taggedItemId);
        }
        return this.http
            .get(`${this.docApi}documents/getdocuments`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to get document by Id ************************** */
    getDocumentDetailsById(documentId: string): Observable<APIRes<Documents>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        return this.http.get(`${this.docApi}documents/` + documentId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to get all  Attachments  ************************** */
    getattachments(id: string): Observable<APIRes<Attachments[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.docApi}attachments/getattachments/${id}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to add an Attachment  ************************** */
    postAttachment(formData: FormData): Observable<APIRes<Attachments[]>> {
        let headers: HttpHeaders = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceid: `${localStorage.getItem('currentInstanceId')}`,
        });

        return this.http.post(`${this.docApi}attachments`, formData, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to update an Attachment  ************************** */
    updateAttachment(formData: FormData): Observable<APIRes<Attachments[]>> {
        let headers: HttpHeaders = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceid: `${localStorage.getItem('currentInstanceId')}`,
        });

        return this.http.put(`${this.docApi}attachments`, formData, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to get tAttachment By Id ************************** */
    getAttachmentById(id): Observable<APIRes<AttachmentDetails>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', `${localStorage.getItem('currentInstanceId')}`);
        return this.http.get(`${this.docApi}attachments/${id}`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to add a Document  ************************** */
    postDocument(formData: FormData): Observable<APIRes<DocumentList[]>> {
        let headers: HttpHeaders = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceid: `${localStorage.getItem('currentInstanceId')}`,
        });

        return this.http.post(`${this.docApi}documents`, formData, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to update an Attachment  ************************** */
    updateDocument(formData: FormData): Observable<APIRes<DocumentList[]>> {
        let headers: HttpHeaders = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceid: `${localStorage.getItem('currentInstanceId')}`,
        });

        return this.http.put(`${this.docApi}documents`, formData, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to delete Uploaded Blob file
    removeDocumentVersion(versionId: string): Observable<APIRes<boolean[]>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', localStorage.getItem('currentInstanceId'));
        return this.http.delete(`${this.docApi}documentversions/` + versionId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to get document link  ************************** */
    getDocumentLinks(id): Observable<APIRes<DocumentLink[]>> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceid', `${localStorage.getItem('currentInstanceId')}`);
        return this.http
            .get(`${this.docApi}documentlinks?documentId=${id}&entityType=173`, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to update an Attachment  ************************** */
    updateDocumentLinks(id: string, payload: DocumentLink[]): Observable<APIRes<DocumentList[]>> {
        let headers: HttpHeaders = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceid: `${localStorage.getItem('currentInstanceId')}`,
        });

        return this.http.put(`${this.docApi}documentlinks/${id}`, payload, { headers: headers }).pipe(catchError(this.handleError.bind(this)));
    }
    //***************API Call to update favourite documents************************** */
    updateIsfavourite(params: any): Observable<{ success?: boolean; isCustom?: boolean; message?: string; response?: any }> {
        this.addPostAndPutHeaders();
        // this.headers = this.headers.append('instanceId', `${localStorage.getItem('currentInstanceId')}`);
        return this.http.put(`${this.docApi}documents/favourite`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // searchDocument(payload: any): Observable<APIRes<{ total: number; data: SearchedDocumnt[] }>> {
    //     this.addPostAndPutHeaders();
    //     return this.http.post(`${this.docApi}documents/searchdocuments`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    // }
    //Method for tagged item allocations
    getTaggedItemAllocations(payload, docId: string): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.docApi}documentlinks/getdocumentlinkhierarchy?documentid=${docId}&Start=${payload.start}&End=${payload.end}`, {
                headers: this.headers,
            })
            .pipe(catchError(this.handleError.bind(this)));
    }
    //Method for WorkPack allocations
    getWorkPackAllocations(payload, docId: string): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(
                `${this.docApi}documentlinks/getdocumentlinkactivitypacks?documentid=${docId}&includeAllocations=false&start=${payload.start}&end=${payload.end}`,
                {
                    headers: this.headers,
                }
            )
            .pipe(catchError(this.handleError.bind(this)));
    }
    searchnames(payload: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.docApi}search/searchnames`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
}
